<template>
    <v-container fluid>
        <v-row class="justify-center">
            <v-col
                cols="12"
                lg="11"
            >
                <v-card>
                    <v-card-title>
                        <h2>Field Map</h2>
                        <v-spacer />
                        <v-btn
                            icon
                            small
                            @click="refresh"
                        >
                            <v-icon small>
                                fas fa-sync
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <ul>
                            <li
                                v-for="(step, index) in map"
                                :key="index"
                            >
                                <b>Step: </b> <router-link :to="'/step/edit/' + step.id">
                                    {{ step.name }}
                                </router-link>
                                <ul v-if="step.sections !== []">
                                    <li
                                        v-for="(section, index) in step.sections"
                                        :key="index"
                                    >
                                        <b>Section: </b>
                                        <router-link :to="'/section/edit/' + section.id">
                                            {{
                                                section.name
                                            }}
                                        </router-link>
                                        <ul v-if="section.cards">
                                            <li
                                                v-for="(card, index) in section.cards"
                                                :key="index"
                                            >
                                                <b>Card: </b>
                                                <router-link :to="'/card/edit/' + card.id">
                                                    {{ card.name }}
                                                </router-link>
                                                <ul v-if="card.field">
                                                    <li
                                                        v-for="(field, index) in card.field"
                                                        :key="index"
                                                    >
                                                        <b>Field: </b>
                                                        <router-link :to="'/field/edit/' + field.id">
                                                            {{
                                                                field.name
                                                            }}
                                                        </router-link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    props: [],

    data() {
        return {
            map: [],
        };
    },

    mounted() {
        this.getFieldMap();
    },

    methods: {
        refresh() {
            this.map = [];
            this.getFieldMap();
        },

        getFieldMap() {
            axios.get('/api/field/map')
                .then((response) => {
                    this.map = response.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
};
</script>
